module.exports = __webpack_public_path__ + "static/media/trigger.41debe9d.png";